import React from 'react';

export default function HotDog() {
	return (
		<g>
			<path fill="#FFCE8D" d="M105.34041,353.72766v0.05786c-0.37891-0.0332-0.76074-0.05811-1.14844-0.05811H38.02401
				c-0.38745,0-0.76904,0.0249-1.14795,0.05811v-0.05786c-8.83691,0-16.00073,10.35474-16.00073,23.12793
				s7.16382,23.12793,16.00073,23.12793h68.46436c8.83716,0,16.00098-10.35474,16.00098-23.12793
				S114.17757,353.72766,105.34041,353.72766z" />
			<path fill="#f96e6e" d="M71.10799,382.10388c-25.54687,0-43.70019-4.08105-44.45996-4.25488
				c-5.38379-1.22998-8.75195-6.59229-7.52148-11.97607c1.23047-5.3833,6.5918-8.75098,11.97656-7.521
				c0.15527,0.03516,16.85742,3.75195,40.00488,3.75195s39.85059-3.71729,40.0166-3.75439
				c5.37891-1.21631,10.73926,2.1543,11.96289,7.53564c1.22266,5.38086-2.13867,10.73486-7.51855,11.96387
				C114.80916,378.02283,96.65486,382.10388,71.10799,382.10388z" />
			<path fill="#ffeaae" d="M71.10896,370.60046c-3.19434,0-6.21875-1.38965-8.29882-3.81348
				c-1.09375-1.27393-2.59668-2.00684-4.24805-2.08252c-1.65723-0.06836-3.19238,0.5083-4.37695,1.64209l-0.03613,0.03564
				c-2.29492,2.2251-5.44238,3.32959-8.61816,3.03857c-3.18262-0.29443-6.06836-1.9585-7.91699-4.56592l-0.08594-0.12256
				c-0.94238-1.33008-2.35547-2.19678-3.97363-2.43555c-1.62109-0.23828-3.22266,0.18359-4.5127,1.18896
				c-1.0918,0.84961-2.66113,0.65186-3.50879-0.43701c-0.84863-1.08936-0.65234-2.66016,0.43652-3.5083
				c2.37988-1.85156,5.33594-2.62988,8.31348-2.18994c2.98242,0.43945,5.58496,2.03613,7.32812,4.49512l0.08594,0.12256
				c1,1.41064,2.56641,2.31396,4.29395,2.47363c1.71387,0.16309,3.4082-0.43262,4.65039-1.62256l0.03613-0.03613
				c2.15527-2.09033,5.10547-3.2124,8.11328-3.07324c3,0.1377,5.84179,1.52344,7.79785,3.80225
				c1.14551,1.33398,2.78711,2.08838,4.52051,2.08838s3.375-0.75439,4.50391-2.06982c1.96875-2.29492,4.8125-3.68115,7.81348-3.81787
				c2.9873-0.14893,5.95703,0.98389,8.11426,3.07617c1.24512,1.2085,2.95215,1.80957,4.67773,1.65039
				c1.72852-0.15918,3.29492-1.06299,4.29785-2.479l0.08789-0.12354c1.73633-2.4502,4.33789-4.04688,7.31836-4.4873
				c2.98633-0.44141,5.93457,0.33594,8.3125,2.18652c1.08984,0.84766,1.28613,2.41846,0.43848,3.5083
				c-0.84766,1.08887-2.41895,1.28613-3.50879,0.43799c-1.29102-1.00439-2.89453-1.42822-4.51074-1.18652
				c-1.61816,0.23926-3.03027,1.10547-3.97559,2.44043l-0.08789,0.12354c-1.84277,2.6001-4.72852,4.26514-7.91309,4.55859
				c-3.1875,0.29443-6.32422-0.81445-8.61914-3.0415c-1.1875-1.15137-2.75-1.74854-4.4043-1.66943
				c-1.65234,0.0752-3.15625,0.80859-4.2334,2.06396C77.32771,369.21033,74.30232,370.60046,71.10896,370.60046z" />
			<path fill="#FFCE8D" d="M104.19244,373.98352c7.17969,0,15.0016,3.81873,15.0016,10.99841s-7.82191,15.00159-15.0016,15.00159
				H38.02428c-7.17969,0-15.0016-7.8219-15.0016-15.00159s7.82191-10.99841,15.0016-10.99841H104.19244z" />
			<path fill="#FFCE8D" d="M104.19244,373.98352c7.17969,0,15.0016,3.81873,15.0016,10.99841s-7.82191,15.00159-15.0016,15.00159
				H38.02428c-7.17969,0-15.0016-7.8219-15.0016-15.00159s7.82191-10.99841,15.0016-10.99841H104.19244z" />
			<path fill="#FFCE8D" d="M104.19244,373.98352c7.17969,0,15.0016,3.81873,15.0016,10.99841s-7.82191,15.00159-15.0016,15.00159
				H38.02428c-7.17969,0-15.0016-7.8219-15.0016-15.00159s7.82191-10.99841,15.0016-10.99841H104.19244z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/HotDog.js